var scrollerInit;

(function ($) {

	// Immediately execute this before any other code runs
	const originalHash = window.location.hash;
	if (originalHash) {
		// Remove hash without triggering scroll
		history.replaceState('', document.title, window.location.pathname + window.location.search);
	}

	const selectors = {
		trigger: 'a[href^="#"]:not([href="#"]):not([data-tabs-link]):not([data-fancybox])',
		scrollTop: '[data-scroll-top]'
	}

	const handleHash = (hash) => {
		if (hash && hash.length > 1) {
			const $target = $(hash);
			if ($target.length) {
				const additionalOffset = $target.is('a') ? 0 : -1 * (document.headerHeightScrolled * 1);
				const targetScroll = $target.offset().top + additionalOffset;
				history.replaceState(null, null, hash);

				setTimeout(_ => {
					window.scrollTo(0, targetScroll);

				}, 100)


			}
		}
	};


	scrollerInit = function () {
		// Handle stored hash on page load
		if (originalHash) {
			handleHash(originalHash);
		}

		$(selectors.trigger).each((i, el) => {
			new Scroller(el);
		});
		$(selectors.scrollTop).each((i, el) => {
			new Scroller(el, 0);
		});
	}


	class Scroller {
		constructor(trigger, offset) {
			this.$trigger = $(trigger);
			this.offset = offset;
			this.$target = $(this.$trigger.attr('href'));

			if (this.$target.length || this.offset !== undefined) {
				this.init();
				this.bind();
			}

		}
		init() {
			this.additionalOffset = this.$target.is('a') ? 0 : -1 * (document.headerHeightScrolled * 1);
		}

		bind() {
			this.$trigger.on('click', this.scroll.bind(this));
		}

		scroll(e) {
			e.preventDefault();
			const $trigger = $(e.delegateTarget);

			if ($trigger.attr('href').length > 1 && $('[data-modal]' + $trigger.attr('href')).length) return;

			const targetScroll = (this.offset === undefined) ? (this.$target.offset().top + this.additionalOffset) : this.offset;

			$('body').addClass('scroller-scrolling');
			$('html, body').animate({
				scrollTop: targetScroll
			}, 700, _ => {
				$('body').removeClass('scroller-scrolling');
			})
		}

	}

})(jQuery);


export default scrollerInit;